import { useUIState } from "@bcm-dev/bcms-vite";
import { CustomAccordionClose, CustomAccordionContent, useCustomAccordion } from 'components/custom-ui/CustomAccordion';
import { FormContainer, FormRowView } from 'components/shared';
import MobileTableAccordionView, { MobileTableAccordionDataItem, MobileTableAccordionToggle } from 'components/shared/views/MobileTableAccordionView';
import { TransferTransaction } from 'model';
import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function MobileTransferHistoryTable
 * @param {ARRAY} transfers - The transfers to show for the table
 * @return {React.Component}
 * @exported true
 * @description The main component for MobileTransferHistoryTable
 * @example
 * <MobileTransferHistoryTable transfers={ transfers } />
 */
export default function MobileTransferHistoryTable(props) {
  const transfers = props.transfers ?? TransferTransaction.initAll().filter(transfer => transfer.status !== "scheduled");
  const transferRows = transfers.map(transfer => {
    return <MobileTransferHistoryItem key={ `Mobile_Transfer_${ transfer.id }` } transfer={ transfer } />
  }, []);

  return (
    <div className="mobile-transfer-history-table show-on-mobile">
        <div className="status-header">
          <b className="status-header-text">Processed</b>
        </div>
      
      { transferRows }
    </div>
  );
}

/**
 * @function MobileTransferHistoryItem
 * @param {TransferTransaction} transfer - The transfer for the item
 * @return {React.Component}
 * @exported true
 * @description The transfer item for the table
 * @example
 * <MobileTransferHistoryItem transfer={ transfer } />
 */
export function MobileTransferHistoryItem(props) {
  const transfer = props.transfer;
  const { key, config } = useUIState(`Mobile_Accordion_${ transfer.id }`, { isActive: false });

  return (
    <MobileTableAccordionView active={ config.active }>
      <MobileTransferHistoryItemHeader transfer={ transfer } />

      <CustomAccordionContent>
        <div className="custom-accordion-content-container">
          <div className="flex-container custom-accordion-header">
            <p className="flex-width">TRANSFER DETAILS</p>

            <CustomAccordionClose className="set-width clickable">
              <SVGAsset id="CloseX" className="icon" />
            </CustomAccordionClose>
          </div>
          
          <FormContainer>
            <FormRowView text="Completion Date" className="light-text">
              <p><b>{ transfer.onDate.format("m/d/Y") }</b></p>
            </FormRowView>

            <FormRowView text="Note" className="light-text">
              <p><b>{ transfer.note }</b></p>
            </FormRowView>
          </FormContainer>
        </div>
      </CustomAccordionContent>
    </MobileTableAccordionView>
  );
}

/**
 * @function MobileTransferHistoryItemHeader
 * @param {TransferTransaction} transfer - The transfer to be shown
 * @return {React.Component}
 * @exported true
 * @description The transfer item header in the table
 * @note This is seperate from the item in-order to use the useCustomAccordion() hook
 * @example
 * <MobileTransferHistoryItemHeader transfer={ transfer } />
 */
export function MobileTransferHistoryItemHeader({ transfer }) {
  const { state } = useCustomAccordion();
  const  transferStatus = transfer.status.charAt(0).toUpperCase() + transfer.status.slice(1)

  return (
    <MobileTableAccordionToggle icon={ state ? "DownChevronIcon" : "RightChevronIcon" } rightValue={ transfer.amount.format() }>
      <MobileTableAccordionDataItem columnHeader="Tracking ID:" data={ transfer.mapID } />
      <MobileTableAccordionDataItem columnHeader="From:" data={ `${ transfer.from?.nickname } - ${ transfer.from?.number }` } />
      <MobileTableAccordionDataItem columnHeader="To:" data={ `${ transfer.to?.nickname } - ${ transfer.to?.number }` } />
      <MobileTableAccordionDataItem columnHeader="Transfer Date:" data={ transfer.onDate.format("m/d/Y") } />
      <MobileTableAccordionDataItem columnHeader={<SVGAsset id="CircleCheckmarkIcon" className="status-icon success" />} data={ transferStatus } />
    </MobileTableAccordionToggle>
  );
}